import { Fragment, Suspense, type JSX } from 'react';

type SuspenseProps = {
	children: JSX.Element | JSX.Element[] | string | string[] | React.ReactNode | null;
	withSuspense?: boolean;
	fallback?: JSX.Element;
};

const SuspenseWrapper: React.FC<SuspenseProps> = ({
	children,
	withSuspense = false,
	fallback = <div className="spinner" />
}) => {
	if (withSuspense) {
		return <Suspense fallback={fallback}>{children}</Suspense>;
	}

	return (
		<Fragment>{children}</Fragment> // eslint-disable-line react/jsx-no-useless-fragment
	);
};

export default SuspenseWrapper;
